import React, {useState} from 'react';
import {
  View,
  TextInput,
  Button,
  Text,
  KeyboardAvoidingView,
  ScrollView,
  Platform,
  StyleSheet,
  Pressable,
  Alert,
  LogBox,
} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import {CountryPicker} from 'react-native-country-codes-picker';

import mystyles from '../../assets/styles/mystyles';
import Auth from '../../auth/AuthHelper';
import EabuServices from '../../components/EabuServices';



export default function SignUpScreen({navigation}) {
  React.useEffect(() => {
    LogBox.ignoreLogs(['InteractionManager has been deprecated']);
  }, []);
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [phone_number, setPhoneNumber] = useState('');

  const [errorMsg, setErrorMsg] = useState('');

  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [agreedToGuidelines, setAgreedToGuidelines] = useState(false);
  const [countryCode, setCountryCode] = useState('US');
  const [dialCode, setDialCode] = useState('+1');
  const [nationalNumber, setNationalNumber] = useState('');

  const [confirmPassword, setConfirmPassword] = useState('');

  const [showCountryPicker, setShowCountryPicker] = useState(false);

  const handlePhoneChange = text => {
    const digits = String(text).replace(/\D/g, '').slice(0, 15);
    setNationalNumber(digits);
    setPhoneNumber(digits ? `${dialCode}${digits}` : '');
  };

  const onSelectCountry = country => {
    const cca2 = country?.cca2 || 'US';
    const firstCalling =
      Array.isArray(country?.callingCode) && country.callingCode.length > 0
        ? `+${country.callingCode[0]}`
        : dialCode;

    setCountryCode(cca2);
    setDialCode(firstCalling);
    setPhoneNumber(nationalNumber ? `${firstCalling}${nationalNumber}` : '');
  };

  const handleSignUp = async () => {
    try {
      if (!agreedToGuidelines) {
        setMessage('You must agree to the community guidelines to sign up.');
        return false;
      }
      const pwd = password || '';
      const confirm = confirmPassword || '';

      if (!pwd) {
        setMessage('Please enter a password.');
        return false;
      }
      if (!confirm) {
        setMessage('Please confirm your password.');
        return false;
      }
      if (pwd !== confirm) {
        setMessage('Passwords do not match.');
        return false;
      }

      setMessage('');

      Alert.alert('Phone: ', phone_number);
      Alert.alert('User: ', username);

      await Auth.signUp({username, password: pwd, email, phone_number});

      setMessage('Sign up successful. Check your email/SMS for the code.');
      return true;
    } catch (e) {
      setMessage(e.message || 'Sign up failed');
      return false;
    }
  };


  React.useEffect(() => {
    const checkUser = async () => {
      try {
        const current = await Auth.getCurrentUser();
        if (current) {
          navigation.replace('Home');
        }
      } catch (e) {
        // Not signed in
      }
    };
    checkUser();
  }, [navigation]);

  return (
    <SafeAreaView style={mystyles.safe} edges={['top', 'left', 'right']}>
      <KeyboardAvoidingView
        style={mystyles.flex}
        behavior={Platform.OS === 'ios' ? 'padding' : 'height'}>
        <ScrollView
          contentContainerStyle={mystyles.scroll}
          keyboardShouldPersistTaps="handled">
          <View style={mystyles.card}>
            <View style={mystyles.form}>
              <TextInput
                style={mystyles.input}
                placeholder="Userid"
                value={username}
                onChangeText={setUsername}
                autoCapitalize="none"
                autoCorrect={false}
                placeholderTextColor="#8A8A8E"
              />

              <TextInput
                style={mystyles.input}
                placeholder="Email"
                value={email}
                onChangeText={setEmail}
                keyboardType="email-address"
                autoCapitalize="none"
                autoCorrect={false}
                placeholderTextColor="#8A8A8E"
                textContentType="emailAddress"
              />

              <TextInput
                value={password}
                onChangeText={setPassword}
                placeholder="Password"
                secureTextEntry
                autoCorrect={false}
                autoCapitalize="none"
                returnKeyType="next"
                style={{
                  borderWidth: 1,
                  borderColor: '#D1D5DB',
                  borderRadius: 8,
                  paddingHorizontal: 12,
                  paddingVertical: 10,
                }}
              />

              <View style={{position: 'relative'}}>
                <TextInput
                  value={confirmPassword}
                  onChangeText={setConfirmPassword}
                  placeholder="Confirm password"
                  secureTextEntry={!showConfirmPassword}
                  autoCorrect={false}
                  autoCapitalize="none"
                  returnKeyType="done"
                  style={{
                    borderWidth: 1,
                    borderColor: '#D1D5DB',
                    borderRadius: 8,
                    paddingHorizontal: 12,
                    paddingVertical: 10,
                    paddingRight: 56,
                  }}
                />
                <Pressable
                  onPress={() => setShowConfirmPassword(v => !v)}
                  hitSlop={8}
                  style={{
                    position: 'absolute',
                    right: 12,
                    top: '50%',
                    transform: [{translateY: -10}],
                    paddingHorizontal: 4,
                    paddingVertical: 2,
                  }}>
                  <Text
                    style={{
                      color: '#2563EB',
                      fontSize: 12,
                      fontWeight: '600',
                    }}>
                    {showConfirmPassword ? 'Hide' : 'Show'}
                  </Text>
                </Pressable>
              </View>

              <View
                style={{flexDirection: 'row', alignItems: 'center', gap: 8}}>
                <Pressable
                  onPress={() => setShowCountryPicker(true)}
                  style={{
                    borderWidth: 1,
                    borderColor: '#D1D5DB',
                    borderRadius: 8,
                    paddingHorizontal: 10,
                    paddingVertical: 10,
                    backgroundColor: '#FFFFFF',
                    minWidth: 72,
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                  <Text style={{color: '#111827', fontWeight: '600'}}>
                    {countryCode}
                  </Text>
                </Pressable>

                <TextInput
                  value={dialCode}
                  editable={false}
                  style={{
                    width: 64,
                    borderWidth: 1,
                    borderColor: '#D1D5DB',
                    borderRadius: 8,
                    paddingHorizontal: 8,
                    paddingVertical: 10,
                    marginRight: 8,
                    color: '#111827',
                    backgroundColor: '#F9FAFB',
                    textAlign: 'center',
                  }}
                />

                <TextInput
                  value={nationalNumber}
                  onChangeText={handlePhoneChange}
                  placeholder="Phone number"
                  keyboardType="phone-pad"
                  autoCorrect={false}
                  autoCapitalize="none"
                  returnKeyType="done"
                  style={{
                    flex: 1,
                    borderWidth: 1,
                    borderColor: '#D1D5DB',
                    borderRadius: 8,
                    paddingHorizontal: 12,
                    paddingVertical: 10,
                  }}
                />
              </View>

              <CountryPicker
                show={showCountryPicker}
                onBackdropPress={() => setShowCountryPicker(false)}
                inputPlaceholder="Search country..."
                searchMessage="No results"
                pickerButtonOnPress={item => {
                  onSelectCountry({
                    cca2: item?.code,
                    callingCode: [
                      String(item?.dial_code || '').replace('+', ''),
                    ],
                  });
                  setShowCountryPicker(false);
                }}
                style={{
                  modal: {
                    height: 280,
                    backgroundColor: '#fff',
                    borderTopLeftRadius: 16,
                    borderTopRightRadius: 16,
                  },
                  textInput: {
                    height: 40,
                    borderRadius: 10,
                    paddingHorizontal: 12,
                    borderWidth: 1,
                    borderColor: '#E5E7EB',
                    backgroundColor: '#F9FAFB',
                  },
                  itemsList: {
                    paddingBottom: 8,
                  },
                  countryButtonStyles: {
                    height: 40,
                  },
                }}
              />

              <Pressable
                onPress={
                  agreedToGuidelines
                    ? async () => {
                        const ok = await handleSignUp();
                        if (ok) {
                          navigation.navigate('ConfirmSignUpScreen', {username});
                        }
                      }
                    : undefined
                }
                disabled={!agreedToGuidelines}
                accessibilityState={{disabled: !agreedToGuidelines}}
                style={({pressed}) => [
                  {
                    backgroundColor: agreedToGuidelines ? '#2563EB' : '#9CA3AF',
                    paddingVertical: 12,
                    borderRadius: 8,
                    alignItems: 'center',
                    justifyContent: 'center',
                    opacity: pressed && agreedToGuidelines ? 0.7 : 1,
                  },
                ]}>
                <Text
                  style={{
                    color: '#FFFFFF',
                    fontSize: 16,
                    fontWeight: '600',
                  }}>
                  Create Account
                </Text>
              </Pressable>

              {!!message && <Text>{message}</Text>}
              {!!errorMsg && <Text style={{color: 'red'}}>{errorMsg}</Text>}
            </View>
          </View>

          <View style={mystyles.linkContainer}>
            <Text style={mystyles.linkPrompt}>Already have an account?</Text>
            <Pressable
              onPress={() => navigation.navigate('SignInScreen')}
              accessibilityRole="button"
              accessibilityHint="Navigates to the sign in screen"
              hitSlop={{top: 10, bottom: 10, left: 10, right: 10}}
              style={({pressed}) => [
                mystyles.linkBtn,
                pressed && mystyles.linkBtnPressed,
              ]}>
              <Text style={mystyles.linkText}>Sign in</Text>
            </Pressable>
          </View>

          <EabuServices />

          <View style={styles.disclaimerCard}>
            <Text style={styles.disclaimerTitle}>Community Guidelines</Text>

            <View style={styles.disclaimerRow}>
              <Text style={styles.disclaimerBullet}>•</Text>
              <Text style={styles.disclaimerText}>
                No sexual content will be uploaded.
              </Text>
            </View>

            <View style={styles.disclaimerRow}>
              <Text style={styles.disclaimerBullet}>•</Text>
              <Text style={styles.disclaimerText}>
                Posts may include location details.
              </Text>
            </View>

            <View style={styles.disclaimerRow}>
              <Text style={styles.disclaimerBullet}>•</Text>
              <Text style={styles.disclaimerText}>
                We may collect seller identity details (e.g., driver’s license,
                photo ID, phone number) — however we do not perform seller's
                background checks.
              </Text>
            </View>
            <View style={styles.disclaimerRow}>
              <Text style={styles.disclaimerBullet}>•</Text>
              <Text style={styles.disclaimerText}>
                All sellers must provide a valid government-issued ID and a
                matching selfie for verification.
              </Text>
            </View>
            <View style={styles.disclaimerRow}>
              <Text style={styles.disclaimerBullet}>•</Text>
              <Text style={styles.disclaimerText}>
                Sellers are responsible for maintaining accurate information.
                Buyers should verify all details directly with the seller and
                exercise their best judgment.
              </Text>
            </View>

            <Pressable
              onPress={() => setAgreedToGuidelines(!agreedToGuidelines)}
              style={{
                marginTop: 12,
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: agreedToGuidelines ? '#10B981' : '#2563EB',
                paddingVertical: 10,
                borderRadius: 8,
              }}>
              <Text style={{color: '#FFFFFF', fontWeight: 'bold'}}>
                {agreedToGuidelines ? '✓ Agreed' : 'I Agree to the Guidelines'}
              </Text>
            </Pressable>
          </View>
        </ScrollView>
      </KeyboardAvoidingView>
    </SafeAreaView>
  );
}

// Add this back (or keep it if it already exists)
const styles = StyleSheet.create({
  disclaimerCard: {
    marginTop: 16,
    marginBottom: 18,
    paddingVertical: 12,
    paddingHorizontal: 14,
    borderRadius: 12,
    backgroundColor: '#F8FAFC',
    borderWidth: 1,
    borderColor: '#E5E7EB',
  },
  disclaimerTitle: {
    textAlign: 'center',
    fontSize: 12,
    fontWeight: '700',
    letterSpacing: 0.3,
    color: '#111827',
    marginBottom: 10,
    textTransform: 'uppercase',
  },
  disclaimerRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 8,
  },
  disclaimerBullet: {
    width: 16,
    textAlign: 'center',
    fontSize: 12,
    lineHeight: 16,
    color: '#2563EB',
    marginTop: 1,
  },
  disclaimerText: {
    flex: 1,
    fontSize: 12,
    lineHeight: 16,
    color: '#6B7280',
  },
});
